import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { DEFAULT_BUTTON_CONFIG } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import AssemblyGameScreen from './AssemblyGameScreen';
import LabelGameScreen from './LabelGameScreen';
import FontKeys from '../FontKeys';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import ABCyaLib from '@abcya/abcya_lib';

export default class IntroScreen extends Phaser.Scene {
  static get KEY() { return 'IntroScreen'; }

  constructor() {
    super({ key: IntroScreen.KEY });
  }

  create() {
    const width = this.scale.width;
    const height = this.scale.height;

    // make shape hole background color we want
    const bgShape = this.add.rectangle(0, 0, width, height, 0x1793C7).setOrigin(0);

    const titleImage = ABCyaPhaser.Images.addImage(width / 2, height / 2 - 100, UIAssetKeys._title, this);

    const skeletalTxt = ABCyaPhaser.Text.addText(titleImage.x - 134, titleImage.y - 4, 64, 0xffd730, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('title.left_part'), this, false).setOrigin(1, 0.5)
      .setShadow(0, 5, '#00679a')
      .setPadding(4, 4);
    const systemTxt = ABCyaPhaser.Text.addText(titleImage.x + 134, titleImage.y - 4, 64, 0xffd730, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('title.right_part'), this, false).setOrigin(0, 0.5)
      .setShadow(0, 5, '#00679a')
      .setPadding(4, 4);

    this.button = this.add.container(width / 2 - 200, height / 2 + 200);
    const bg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._label_button, this.button);
    ABCyaPhaser.Container.setContainerInteractive(this.button);

    const txt = ABCyaPhaser.Text.addText(0, -16, 28, 0xf99f1c, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('label_button'), this.button);
    ABCyaPhaser.Buttons.convertToButton(this.button, { onClick: () => this.showLabelGame(), ...DEFAULT_BUTTON_CONFIG });

    this.button2 = this.add.container(width / 2 + 200, height / 2 + 200);
    const bg2 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._assemble_button, this.button2);
    ABCyaPhaser.Container.setContainerInteractive(this.button2);

    const txt2 = ABCyaPhaser.Text.addText(0, -22, 28, 0xf99f1c, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('assemble_button'), this.button2);
    ABCyaPhaser.Buttons.convertToButton(this.button2, { onClick: () => this.showAssembleGame(), ...DEFAULT_BUTTON_CONFIG });

    this._titleVO = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this._titleVO.once(Phaser.Sound.Events.COMPLETE, () => {
      this._titleVO.destroy();
      this._titleVO = null;
      this.playLabelSound(() => {
        this.playAssembleSound();
        ABCyaPhaser.Tweens.addTween(this.button2, 200, { scale: 1.2, delay: 300 + ABCyaLib.Environment.instance.gameConfig.delayBetweenTitleVO }, Phaser.Math.Easing.Bounce.Out, () => {
          ABCyaPhaser.Tweens.addTween(this.button2, 200, { scale: 1 }, Phaser.Math.Easing.Bounce.Out);
        });
      });
      ABCyaPhaser.Tweens.addTween(this.button, 200, { delay: ABCyaLib.Environment.instance.gameConfig.delayBetweenTitleVO, scale: 1.2 }, Phaser.Math.Easing.Bounce.Out, () => {
        ABCyaPhaser.Tweens.addTween(this.button, 200, { scale: 1 }, Phaser.Math.Easing.Bounce.Out);
      });
    });
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._title, this._titleVO);
  }

  showLabelGame() {
    this.sound.stopAll();
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    this.tweens.killAll();

    this.scene.start(LabelGameScreen.KEY);
  }

  showAssembleGame() {
    this.sound.stopAll();
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    this.tweens.killAll();

    this.scene.start(AssemblyGameScreen.KEY);
  }

  playAssembleSound() {
    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._assemble, this, 1, false, ABCyaLib.Environment.instance.gameConfig.delayBetweenTitleVO / 1000, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
  }

  playLabelSound(onComplete) {
    this._labelVO = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this._labelVO.once(Phaser.Sound.Events.COMPLETE, () => {
      this._labelVO.destroy();
      this._labelVO = null;
      onComplete();
    });
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._label, this._labelVO, 1, false, ABCyaLib.Environment.instance.gameConfig.delayBetweenTitleVO / 1000);
  }
}